import { render, staticRenderFns } from "./MinimalStock.vue?vue&type=template&id=37c10bc6&"
import script from "./MinimalStock.vue?vue&type=script&lang=js&"
export * from "./MinimalStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports